'use client'

import { useRouter } from 'next/navigation'
import { Icon } from '../Icon'
import { BaseHeader } from './BaseHeader'

type Props = {
  backUrl?: string
  rightComponent?: React.ReactNode
}

export const BackHeader = ({ backUrl, rightComponent }: Props) => {
  const router = useRouter()
  const onBack = () => {
    if (backUrl) {
      router.replace(backUrl)
      return
    }

    router.back()
  }

  return (
    <BaseHeader>
      <Icon name="arrow-left" size={24} onClick={onBack} />

      {rightComponent && (
        <div className="ml-auto flex items-center gap-4">
          <Icon name="search" size={24} href="/search" />
          {rightComponent}
        </div>
      )}
    </BaseHeader>
  )
}
